<section class="section about" id="about">
  <div class="container">
    <div class="section-box">
      <div class="about-title" data-aos="fade-up">
        <h3 class="section-title">
          <span class="n-section-title">01.</span>
          {{ "AboutMe.Title" | translate }}
        </h3>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 mb-4 mb-md-0">
          <div class="about-description">
            <p
              *ngFor="let text of paragraphs"
              [innerHTML]="text"
              data-aos="fade-up"
              data-aos-duration="1000"
            ></p>
          </div>
        </div>
        <div
          class="col-12 col-md-6 mt-4 mt-md-0 text-center"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          <div class="about-img-container">
            <img
              width="300"
              height="300"
              src="assets/images/me/logo-light.svg"
              alt="Git User"
            />
          </div>
        </div>
      </div>
      <div class="row" data-aos="fade-up" data-aos-duration="1000">
        <div class="col-12 mb-4 mb-md-0">
          <ul class="skills-list" data-aos="fade-up">
            <li
              class="skill-element"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <span class="underline">Angular, React</span>
            </li>
            <li
              class="skill-element"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <span class="underline">RxJS, NgRx, Context API</span>
            </li>
            <li
              class="skill-element"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <span class="underline"
                >HTML, CSS, SCSS, Bootstrap, Material</span
              >
            </li>
            <li
              class="skill-element"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <span class="underline">JavaScript (ES6+), TypeScript, Go</span>
            </li>
            <li
              class="skill-element"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <span class="underline">Node.js, Express.js</span>
            </li>
            <li
              class="skill-element"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <span class="underline">REST APIs</span>
            </li>
            <li
              class="skill-element"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <span class="underline">MongoDB, Redis, Firebase</span>
            </li>
            <li
              class="skill-element"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <span class="underline"
                >Testing: Jasmine, Karma, Jest, Mocha, Chai</span
              >
            </li>

            <li
              class="skill-element"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <span class="underline">Docker, Kubernetes, Nginx, Linux</span>
            </li>
            <li
              class="skill-element"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <span class="underline">Agile/Scrum, Jira, Confluence</span>
            </li>
            <li
              class="skill-element"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <span class="underline"
                >Version Control: Git, GitHub, GitLab</span
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
